// Main entry point — registers components and resolves the session before render.

import './components/app-root.js'
import './components/app-nav.js'
import './components/app-router.js'
import './components/app-toast.js'
import './components/page-login.js'
import './components/page-onboarding.js'
import './components/page-calendar.js'
import './components/page-day.js'
import './components/page-settings.js'
import './components/page-reports.js'
import './components/page-not-found.js'

import { bootstrapAuth } from './bootstrap.js'

bootstrapAuth()
